<template>
  <div id="cover">
    <div class="cover container">
      <h1>{{$t(`tunnel.step${currentStep}.title`)}}</h1>
      <ul id="steps">
        <li :class="{current: currentStep === 2, done: currentStep > 2, disabled: true}">
          <div>
            <span class="icon">
              <img src="/static/img/icon_step2.png" alt="">
            </span>
            <h3>{{$t('tunnel.stepLabel', 1)}}</h3>
            <h4>{{$t('tunnel.step2.label')}}</h4>
          </div>
        </li>
        <li :class="{current: currentStep === 3, done: currentStep > 3, disabled: btnDisabled || currentStep < 3}">
          <div>
            <span class="icon">
              <img src="/static/img/icon_step3.png" alt="">
            </span>
            <h3>{{$t('tunnel.stepLabel', 2)}}</h3>
            <h4>{{$t('tunnel.step3.label')}}</h4>
          </div>
        </li>
        <li :class="{current: currentStep === 4, done: currentStep > 4, disabled: btnDisabled || currentStep < 4}">
          <div>
            <span class="icon">
              <img src="/static/img/icon_step4.png" alt="">
            </span>
            <h3>{{$t('tunnel.stepLabel', 3)}}</h3>
            <h4>{{$t('tunnel.step4.label')}}</h4>
          </div>
        </li>
      </ul>
    </div>
    <div class="gradientslider"></div>
  </div>
</template>

<script>
export default {
  name: 'step-navbar',
  props: ['currentStep', 'disableBtn'],
  computed: {
    btnDisabled () {
      return !this.disabled;
    }
  }
};
</script>

<style scoped>
  li.disabled a:hover > span {
    background-color: #fff!important;
    background-position: center bottom!important;
  }
  li.disabled a:hover > h3 {
    color: rgba(40,40,50,.5)!important;
  }
  li.disabled a:hover > h4 {
    color: rgba(120,120,150,.5)!important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/tunnel/step-navbar.vue